/* eslint-disable */
import { Component } from "react";
import {
  Grid,
  GridItem,
} from "@chakra-ui/react";
import {
  createStyles,
  Theme,
  withStyles,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";

import { connectModal } from "redux-modal";
import { withTranslation } from "react-i18next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import {
  addDocument,
  getDirectoryDocuments,
  getRootDocumentsAndDirectories,
  addDirectory,
  addDocumentFund,
  getFundEnvelopes,
  addEnvelopePart,
  getPartEnvelopes,
  getDocumentPart,
  addDocumentPart,
} from "../../utils/store/actions/document.actions";
import "react-toastify/dist/ReactToastify.css";

import { B4FText } from "../component-questionnaire/B4FFields/B4FText";
const styles = (theme: Theme) =>
  createStyles({
    dropzone: {
      minHeight: "150px",
      marginBottom: "20px",
    },
    previewChip: {
      width: "100px",
    },
  });
class ModalAddDocumentInDirectory extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      documentName: "",
      directoryName: "",
      parentDirectoryId: this.props.parentDirectoryId,
    };
  }

  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  partId = this.urlParams.get("partId");
  fundPersonId = this.urlParams.get("id");

  handleChange = (e: any) => {
    this.setState({
      [e.id]: e.value,
    });
  };

  async handleDocument(files: any) {
    const fileData = new FormData();
    fileData.append("file", files[0]);

    this.setState({
      file: fileData,
      documentName: !!this.state.documentName
        ? this.state.documentName
        : files[0]?.name,
    });
  }
  async handleDocumentUpload() {
    if (this.props.actionDone === "DOCUMENT_FUND") {
      await this.props.addDocumentFund(
        this.state.documentName,
        this.props.Funds.fund.person.id,
        this.state.file,
        this.props.parentDirectoryId
      );
      this.props.getDirectoryDocuments(
        this.state.parentDirectoryId,
        "fund",
        this.props.Funds.fund.person.id
      );
    } else if (this.props.actionDone === "DOCUMENT_PART") {
      await this.props.addDocumentPart(
        this.state.documentName,
        this.fundPersonId,
        this.partId,
        this.state.file,
        this.props.parentDirectoryId
      );
      this.props.getDocumentPart(
        this.fundPersonId,
        this.partId,
        this.state.parentDirectoryId,
      );
     } else {
      await this.props.addDocument(
        this.state.documentName,
        this.props.parentDirectoryId,
        this.state.file
      );
      if (!!this.props.parentDirectoryId) {
        this.props.getDirectoryDocuments(this.props.parentDirectoryId);
      } else {
        this.props.getRootDocumentsAndDirectories();
      }
    }
  }
  async handleDirectoryUpload() {
    if (this.props.actionDone === "DIRECTORY_FUND") {
      await this.props.addDirectory(
        this.state.directoryName,
        this.props.parentDirectoryId,
        this.props.actionDone
      );
      await this.props.getFundEnvelopes(this.props.Funds.fund.person.id);
    } else if (this.props.actionDone === "DIRECTORY_PART") {
      await this.props.addEnvelopePart(
        this.state.directoryName,
        this.fundPersonId,
        this.partId,
      )
      await this.props.getPartEnvelopes(this.fundPersonId, this.partId);
    } else {
      await this.props.addDirectory(
        this.state.directoryName,
        this.props.parentDirectoryId,
        this.props.actionDone
      );
      if (!!this.props.parentDirectoryId) {
        this.props.getDirectoryDocuments(this.props.parentDirectoryId);
      } else {
        this.props.getRootDocumentsAndDirectories();
      }
    }
  }
  render() {
    const { show, handleHide, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <div>
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            backgroundColor: "#f5f6ff",
            top: "20%",
            maxWidth: "fit-content",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "#f5f6ff",
              fontWeight: "bolder",
            }}
          >
            {this.props.actionDone === "DOCUMENT" ||
              this.props.actionDone === "DOCUMENT_FUND" ||
              this.props.actionDone === "DOCUMENT_PART"
              ? t("ADD_DOCUMENT")
              : t("ADD_DIRECTORY")}
          </ModalHeader>
          {this.props.actionDone === "DOCUMENT" ||
            this.props.actionDone === "DOCUMENT_FUND" ||
          this.props.actionDone === "DOCUMENT_PART" ? (
            <ModalBody
              style={{
                backgroundColor: "#f5f6ff",
              }}
            >
              <Grid
                templateRows="repeat(1, 1fr)"
                templateColumns="repeat(2, 1fr)"
                style={{
                  backgroundColor: "white",
                  padding: "5%",
                  borderRadius: "5px",
                  minWidth: "700px",
                }}
              >
                <GridItem rowSpan={1} colSpan={2}>
                  <div style={{ position: "relative", height: "100%" }}>
                    <DropzoneArea
                      dropzoneClass={classes.dropzone}
                      showFileNames
                      showPreviews={true}
                      showPreviewsInDropzone={false}
                      useChipsForPreview
                      previewGridProps={{
                        container: { spacing: 1, direction: "row" },
                      }}
                      previewChipProps={{
                        classes: { root: classes.previewChip },
                      }}
                      previewText="File:"
                      dropzoneText={t("UPLOAD")}
                      maxFileSize={100000000}
                      filesLimit={1}
                      onChange={this.handleDocument.bind(this)}
                    />
                  </div>
                </GridItem>
              </Grid>
            </ModalBody>
          ) : (
            <ModalBody
              style={{
                backgroundColor: "#f5f6ff",
              }}
            >
              <Grid
                templateRows="repeat(1, 1fr)"
                templateColumns="repeat(2, 1fr)"
                style={{
                  backgroundColor: "white",
                  padding: "5%",
                  borderRadius: "5px",
                  minWidth: "700px",
                }}
              >
                <GridItem rowSpan={1} colSpan={2}>
                  <B4FText
                    label="DIRECTORY_NAME"
                    id="directoryName"
                    key="name"
                    value={this.state.directoryName}
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => {
                      this.handleChange(e);
                    }}
                    visible={true}
                    isRequired={true}
                  />
                </GridItem>
              </Grid>
            </ModalBody>
          )}

          <ModalFooter
            style={{
              backgroundColor: "#f5f6ff",
              borderRadius: "10px",
            }}
          >
            <>
              <Button
                style={{
                  color: "rgb(99, 110, 149)",
                  border: "2px solid",
                  background: "none",
                }}
                onClick={handleHide}
              >
                {t("CANCEL")}
              </Button>
              {this.props.actionDone === "DOCUMENT" ||
              this.props.actionDone === "DOCUMENT_FUND" || this.props.actionDone === "DOCUMENT_PART" ? (
                <Button
                  disabled={this.state.documentName === ""}
                  style={{ backgroundColor: "#ae0064", color: "white" }}
                  onClick={() => {
                    this.handleDocumentUpload(), handleHide();
                  }}
                >
                  {t("CREATE")}
                </Button>
              ) : (
                <Button
                  style={{ backgroundColor: "#ae0064", color: "white" }}
                  onClick={() => {
                    this.handleDirectoryUpload(), handleHide();
                  }}
                >
                  {t("CREATE")}
                </Button>
              )}
            </>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  addDocument,
  getRootDocumentsAndDirectories,
  getDirectoryDocuments,
  addDirectory,
  addDocumentFund,
  getFundEnvelopes,
  addEnvelopePart,
  getPartEnvelopes,
  getDocumentPart,
  addDocumentPart,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(
      connectModal({ name: "add_doc_directory" })(ModalAddDocumentInDirectory)
    )
  )
);
